import { useState } from 'react';
import { Navigate, Routes, Route, useSearchParams } from 'react-router-dom';
import { useAppBasePath } from '../_shared/base-path';
import { GuidedApp } from './components/v3/GuidedApp';
import { StoryRouteV3 } from './components/v3/deck/StoryRouteV3';
import './styles.css';

/**
 * Value Calculator.
 *   index    — the v3 guided flow (homepage: approach table + Build a business case)
 *   /explain — redirects to the homepage (the explain path was dropped; the table lives there now)
 *   /deck    — redirects to the homepage (the old intro deck, replaced the same way)
 *   /story   — the v3 executive deck, read from the `clay-value-story-v1` snapshot the ROI summary's deck button writes
 * Share links use ?s=<base64>: v3 links and every v2 link open in the v3 flow, through the migration
 * (a v2 link's unmappable answers show as re-check flags in the review).
 */

function GuidedRoute() {
  const [searchParams, setSearchParams] = useSearchParams();
  // Read the share link once; the shell loads it through the migration, then we strip the param so a
  // reload of the stripped URL does not re-apply a stale link over newer local edits.
  const [share] = useState(() => searchParams.get('s'));
  return (
    <GuidedApp
      initialShare={share}
      onShareConsumed={() => setSearchParams({}, { replace: true })}
    />
  );
}

/** Old `/explain` and `/deck` links land on the homepage, which now holds the approach table. */
function HomeRedirect() {
  const basePath = useAppBasePath();
  return <Navigate to={basePath} replace />;
}

export default function ValueCalculator() {
  return (
    <div className="vc-root">
      <Routes>
        <Route index element={<GuidedRoute />} />
        <Route path="explain" element={<HomeRedirect />} />
        <Route path="deck" element={<HomeRedirect />} />
        <Route path="story" element={<StoryRouteV3 />} />
      </Routes>
    </div>
  );
}
